import { useCallback } from "react";
import type { Exercise, PlanStarter } from "@heraion/shared";
import { useWorkoutStarter as useSharedWorkoutStarter } from "@heraion/ui";

import { apiFetch } from "./api";
import { useMaxesDataWeb } from "./maxes/useMaxesDataWeb";

// Web mount of the shared start orchestration (@heraion/ui useWorkoutStarter,
// CN-workoutstarter-twin). The three seams: MAXes from the shared
// useMaxesData layer, bodyweight handed in by the screen that already holds
// the profile, and the hand-off to AppShell, which opens the Logger on the
// Workouts tab (web-rnw's LoggerScreen takes `planStarter` as a prop).
export function useWorkoutStarter(
  catalog: Exercise[] | null,
  bodyweightKg: number | null,
  onStarter: (starter: PlanStarter) => void,
) {
  const { getFreshDetailed } = useMaxesDataWeb();
  const getBodyweightKg = useCallback(
    () => Promise.resolve(bodyweightKg),
    [bodyweightKg],
  );
  return useSharedWorkoutStarter({
    apiFetch,
    catalog,
    getMaxesDetailed: getFreshDetailed,
    getBodyweightKg,
    onStarter,
  });
}
